import React, { useState } from 'react'

import { Icon } from '@iconify/react'

import MerchModal from './merchModal'

import { nanoid } from 'nanoid'

import { Link } from 'gatsby'

const Cart = ({ cart, itemCount }) => {

    const [ showCart, setShowCart ] = useState(false)

    const cartTotal = cart.reduce((accum,item) => accum + item.price, 0)

    return (
        <div>
            <div className="cart-icon">
                <Icon icon="bi:cart" className="is-size-2 is-clickable"
                    hFlip={true} onClick={() => setShowCart(true)} onKeyDown={() => setShowCart(true)} 
                    role="button" tabIndex={-1} 
                />
                { itemCount > 0 && <div className="item-count">{itemCount}</div> }
            </div>

            {
                showCart && 
                    <div className="cart">
                        <h2 className="has-text-centered is-size-2">Cart</h2>
                        <Icon icon="fontisto:close-a" color="#d6b455" className="is-size-1 hover is-clickable pl-3"
                            onClick={() => setShowCart(false)} onKeyDown={() => setShowCart(false)}
                            role="button" tabIndex={-1}
                        />
                        <div className="has-text-centered my-3">
                            <h3 className="is-size-4">TOTAL: <span>₦{cartTotal}</span></h3>
                        </div>
                        <Link to="/merch/checkout" state={{ cart, cartTotal }}>
                            <button className="button mb-4 merch-button is-size-4">Checkout</button>
                        </Link>
                        <h2 className="is-size-3 my-3 pl-3">Items</h2>
                        { cart.map((item) =>
                            <MerchModal attributes={item} isCartOpen={true} key={nanoid()}/>
                        )}
                    </div>
            }
        </div>
    )
}

export default Cart
